import { render } from "./OrderGuide.vue?vue&type=template&id=d624dfb8&scoped=true"
import script from "./OrderGuide.vue?vue&type=script&lang=js"
export * from "./OrderGuide.vue?vue&type=script&lang=js"

import "./OrderGuide.vue?vue&type=style&index=0&id=d624dfb8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d624dfb8"]])

export default __exports__